import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/user_management',
  component: Layout,
  name: 'userManagement',
  meta: {
    title: '用户管理',
    icon: 'i-ant-design:user-outlined',
  },
  children: [
    {
      path: 'user_list',
      name: 'userManagementUserList',
      component: () => import('@/views/user_management/user_list.vue'),
      meta: {
        title: '用户列表',
        icon: 'i-ant-design:unordered-list-outlined',
      },
    },
    {
      path: 'account_change',
      name: 'userManagementAccountChange',
      component: () => import('@/views/user_management/account_change.vue'),
      meta: {
        title: '账变明细',
        icon: 'i-ant-design:account-book-outlined',
      },
    },
    {
      path: 'group_list',
      name: 'userManagementGroupList',
      component: () => import('@/views/user_management/group_list.vue'),
      meta: {
        title: '团队列表',
        icon: 'i-ant-design:team-outlined',
      },
    },
    {
      path: 'group_down_list',
      name: 'userManagementGroupDownList',
      component: () => import('@/views/user_management/group_down_list.vue'),
      meta: {
        title: '下级成员',
        menu: false,
        /** 按 fullPath 区分标签，支持同路由多开（如不同 userID/层级） */
        multiTab: true,
      },
    },
    {
      path: 'virtual_currency_address',
      name: 'userManagementVirtualCurrencyAddress',
      component: () => import('@/views/user_management/virtual_currency_address.vue'),
      meta: {
        title: '虚拟币地址',
        icon: 'i-ant-design:wallet-outlined',
      },
    },
    {
      path: 'invite_code',
      name: 'userManagementInviteCode',
      component: () => import('@/views/user_management/invite_code.vue'),
      meta: {
        title: '邀请码',
        icon: 'i-ant-design:gift-outlined',
      },
    },
    {
      path: 'login_history',
      name: 'userManagementLoginHistory',
      component: () => import('@/views/user_management/login_history.vue'),
      meta: {
        title: '登录历史',
        icon: 'i-ant-design:history-outlined',
      },
    },
    {
      path: 'user_recharge_address',
      name: 'userManagementUserRechargeAddress',
      component: () => import('@/views/user_management/user_recharge_address.vue'),
      meta: {
        title: '用户充值地址',
        icon: 'i-ant-design:credit-card-outlined',
      },
    },
  ],
}

export default routes
